import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { PHOTO } from "../../assets";
import { useNavigate } from "react-router-dom";

function PhotoGallery() {
  const navigate = useNavigate();
  return (
    <LandingPageLayout
      title={<>Picture Gallery</>}
      currentLink={"Picture Gallery"}
    >
      <div className="py-8 sm:py-10 px-4 sm:px-8 lg:px-20 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-10 bg-[#F7F7F7]">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => (
          <div
            key={index}
            onClick={() => navigate("/photo-details")}
            className="w-full h-fit bg-white gap-y-2 sm:gap-y-3 flex flex-col items-center rounded-md p-2 sm:p-3 cursor-pointer hover:shadow-lg transition-shadow"
          >
            <img
              src={PHOTO}
              className="w-full h-[150px] sm:h-[180px] lg:h-[207px] object-cover rounded-md"
              alt="Gallery Image"
            />
            <span className="text-primary-300 text-center text-xs sm:text-sm font-medium leading-relaxed px-2">
              Swearing In of Chairmen & Members
            </span>
          </div>
        ))}
      </div>
    </LandingPageLayout>
  );
}

export default PhotoGallery;
